import { IEquipmentModel } from '../../equipmentModels.types.ts'
import { useRecoilValue } from 'recoil'
import equipmentModelsAtom from '../../equipmentModels.atom.ts'
import { useMemo } from 'react'
import Tag from '../../../../../../shared/Tags/Tag'

interface IProps {
  ids: Array<IEquipmentModel['id']>
}

const EquipmentModelsTags = (props: IProps) => {
  const equipmentModels = useRecoilValue(equipmentModelsAtom).items

  const models = useMemo(() => {
    return equipmentModels.filter((e) => props.ids.includes(e.id))
  }, [props.ids, equipmentModels])

  return (
    <div className="inline-flex-gap gap8">
      {models.map((m, index) => (
        <Tag color="gray" key={index}>
          {m.name}
        </Tag>
      ))}
    </div>
  )
}

export default EquipmentModelsTags
